<template>
  <!--收藏功能-->
  <div class="share-favourite">
    <div class="favourite" @click="onClick">
      <img src="@/assets/star-fill.png" v-if="fav" />
      <img src="@/assets/star.png" v-else />
      <div>{{fav ? '已收藏' : '收藏'}}</div>
    </div>
    <!--分享功能-->
    <div class="share favourite" @click="handleShare" v-if="targetName !== 'service'">
      <img src="@/assets/share.png"/>
      <div>分享</div>
    </div>
    <div class="share-dialog" v-show="dialogShow">
      <canvas id="qr-code"></canvas>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
export default {
  name: "Favourite",
  props: ["targetName", "targetId", "purchaseLevel"],
  data() {
    return {
      fav: 0,
      dialogShow:false,
      url:`${this.util.shareWxUrl()}?id=${this.targetId}&purchaseLevel=${this.purchaseLevel}`,
    };
  },
  created() {
    this.init();
    document.addEventListener('click', this.handleOther)
  },
  computed: {
      get() {
          if(this.targetName === 'product') {
              return this.$store.state.product.productBase.get
          }else {
              return this.$store.state.ovop.oneVillageOneProduct.get
          }
      }
    },
  methods: {
    async init() {
      const fav = await this.ajax.doPost({
        packageName: "user",
        className: "userFavorite",
        methodName: "isCollect",
        params: {
          targetName: this.targetName,
          targetId: this.targetId
        }
      });

      this.fav = fav;
    },
    async onClick() {
      if (this.fav === 0) {
        this.fav = 1;
      } else {
        this.fav = 0;
      }

      if (this.fav === 1) {
        await this.ajax.doPost({
          packageName: "user",
          className: "userFavorite",
          methodName: "create",
          params: {
            targetName: this.targetName,
            targetId: this.targetId
          }
        });
      } else {
        await this.ajax.doPost({
          packageName: "user",
          className: "userFavorite",
          methodName: "delete",
          params: {
            targetName: this.targetName,
            targetId: this.targetId
          }
        });
      }
    },
    /**
     * 分享
     * @author Ren YuLei 2020/10/15
     */
    handleShare(e) {
        e.stopPropagation()
        const productInfo = this.get
        // 商品名称、商品主图（支持多张）、属性、上市时间（具体时间）、存储方法、挑选窍门、食用方法、商品故事、商品产地、商品产地图片、生长周期、生长周期图片
        const productKeyList = ['name', 'images', 'features', 'timeToMarket', 'storageMeans',
            'acceptanceStandard', 'edibleMethods','story', 'place', 'placeImages', 'lifeCycles',  'lifeCyclesImages']
        let isLack = productKeyList.every(item=>Boolean(productInfo[item]))  // 信息是否缺少
        if(isLack){
            this.dialogShow = true
            QRCode.toCanvas(document.getElementById('qr-code'), this.url, {   // 生成微信二维码
                errorCorrectionLevel: 'H',
                width: 160,
            })
        }else {
            this.$message.warning('商品基础信息不完整，暂不支持分享，请补充相关信息')
        }
    },
    handleOther(){
        this.dialogShow = false
    }
  }
};
</script>

<style lang="less">
  .share-favourite{
    display: inline-block;
    position: relative;
  }
.favourite {
  display: inline-block;
  vertical-align: top;
  border-radius: 16px;
  height: 30px;
  border: 1px solid rgba(191, 191, 191, 1);
  text-align: center;
  cursor: pointer;
  width: 100px;

  img {
    width: 20px;
    height: 20px;
    display: inline-block;
    margin: 5px 5px 5px 15px;
  }
  div {
    margin: 5px 15px 5px 0px;
    display: inline-block;
    line-height: 20px;
    vertical-align: top;
    font-size: 14px;
  }
}
  .share{
    margin-left: 15px;
  }
  .share-dialog {
    position: absolute;
    width: 160px;
    height: 160px;
    top: 40px;
    left: 95px;
    z-index: 2;
    background: #fff;
    box-shadow: 0 9px 18px 0 rgba(0, 0, 0, 0.06);
  }
</style>

